<template>
  <section>
    <div class="mb-2">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="headline" v-text="content.title"></div>
          <div
            class="subtitle-1 grey--text text--darken-2"
            v-text="content.subtitle"
          ></div>
        </div>
        <template v-if="content.headerButton != null">
          <div class="flex-shrink-1">
            <v-btn text :color="$buttonColor" @click="more()">
              <!-- {{ $vuetify.lang.t("$vuetify.actions.more") }} -->
              {{ content.headerButton.title }}
              <v-icon right small>far fa-chevron-right</v-icon>
            </v-btn>
          </div>
        </template>
      </div>
    </div>

    <v-row>
      <template v-for="item of content.body">
        <v-col
          cols="12"
          :md="mdComputed"
          :lg="lgComputed"
          :key="`cours_${item._id}`"
        >
          <v-hover v-slot:default="{ hover }">
            <v-card
              class="hoverable card-growable"
              :height="400"
              :elevation="hover ? 6 : 2"
              ripple
              @click="navigate(item)"
            >
              <v-img
                class="grey"
                max-width="100%"
                width="auto"
                height="200px"
                :src="item.image"
                :lazy-src="item.image"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-sheet
                      width="100%"
                      height="100%"
                      color="grey lighten-3"
                      class="d-flex justify-center"
                    >
                      <v-icon x-large color="grey lighten-1"
                        >mdi mdi-image-area</v-icon
                      >
                    </v-sheet>
                  </v-row>
                </template>
              </v-img>
              <v-card-subtitle
                class="subtitle-2 pb-3"
                v-text="item.categories[0].title"
              ></v-card-subtitle>
              <div
                style="max-height: 72px; overflow-y: hidden"
                class="body-2 py-0 px-4"
                v-text="item.title"
              ></div>

              <v-card-text>
                <v-divider class="my-3"></v-divider>
                <div class="d-flex">
                  <div>
                    <v-rating
                      half-increments
                      half-icon="fas fa-star-half-alt"
                      background-color="grey"
                      color="amber"
                      readonly
                      dense
                      small
                      :value="item.rating"
                    ></v-rating>
                  </div>
                  <div class="flex-grow-1">
                    (
                    <span v-text="item.rating"></span>
                    )
                  </div>
                  <div class="text-right">
                    <v-icon small class="mr-2 fa-fw"
                      >far fa-comments-alt</v-icon
                    >
                    <span>{{ item.countComment }}</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </template>
    </v-row>

    <template v-if="content.footerButton != null">
      <div class="mt-3">
        <v-btn :color="$buttonColor" large outlined @click="more()">
          <!-- {{ $vuetify.lang.t("$vuetify.actions.more") }} -->
          {{ content.footerButton.title }}
          <v-icon right small>far fa-chevron-right</v-icon>
        </v-btn>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: "course_vertical_gridview",
  props: ["content", "md", "lg"],
  computed: {
    lgComputed() {
      if (this.lg != null && this.lg != 0) {
        return this.lg;
      }

      return 3;
    },
    mdComputed() {
      if (this.md != null && this.md != 0) {
        return this.md;
      }

      return 4;
    },
  },
  methods: {
    more() {
      const qs = this.$utility.queryStringToJson(
        this.content.footerButton
          ? this.content.footerButton.queries
          : this.content.headerButton.queries
      );
      this.$router.push({
        name: "course",
        query: qs,
      });
    },
    navigate(item) {
      this.$router.push({
        name: "course_detail",
        params: {
          id: item._id,
        },
      });
    },
  },
};
</script>